import React, { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Layout from "../Components/Layout/Body/index";
import { LandingPage } from "../Pages/LandingPage";
import Dashboard from "../Pages/Dashboard";
import CandidateDetail from "../Pages/Dashboard/CandidateDetail";
import ProtectedRoute from "./protectedRoute";

const RoutePath = ({ isDarkTheme }) => {
  const navigate = useNavigate();

  // Catch a userToken on any URL (e.g. landing on "/" from an external app),
  // store it, strip it from the address bar, and go straight to the dashboard.
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const userToken = urlParams.get("userToken");

    if (userToken) {
      localStorage.setItem("authToken", userToken);

      const url = new URL(window.location.href);
      url.searchParams.delete("userToken");
      window.history.replaceState({}, document.title, url.pathname + url.search);

      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return (
    <div className="App">
      <Routes>
        {/* Public Routes without Layout (no header/menu) */}

        <Route element={<Layout isDarkTheme={isDarkTheme} />}>
          {/* Public Landing Page */}
          <Route path="/" element={<LandingPage />} />

          {/* Protected Routes - Only accessible from oruclicks.com */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/candidate/:profileId" element={<CandidateDetail />} />
          </Route>
        </Route>
      </Routes>
    </div>
  );
};
export default RoutePath;
